<div class="property">
  <div class="title">
    {{ 'label.verifiedDate' | translate }}
  </div>
  @if (agreement.verified && agreement.verificationTimestamp; as verifiedDate) {
    <div>
      <span class="status">{{
        'agreement.verified.date'
          | translate
            : {
                date: verifiedDate | formatDateTime,
                propertyValue: agreement.verificationValue
              }
      }}</span>
      <ax-icon class="icon green-text" name="check-decagram"></ax-icon>
    </div>
  }
  @if (!agreement.verified) {
    <div class="verify-wrapper">
      {{ 'agreement.unverified' | translate }}
      <ax-icon class="icon orange-text" name="check-decagram-outline"></ax-icon>
    </div>
  }
</div>
